import React from 'react';

export let StoreContext = React.createContext("Store");